import { useEffect } from 'react';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../../../store/actions';

export const useLottoRootURL = () => {
    const { lottoRootURLLocaleMapping, defaultLocale } = useAppSelector(pick(['lottoRootURLLocaleMapping', 'defaultLocale']));
    const lang = useUserSelector(prop('lang'));
    const dispatch = useDispatch();

    useEffect(() => {
        if (!lang || !defaultLocale) {
            return;
        }

        const lottoRootURL = lottoRootURLLocaleMapping[lang] ?? lottoRootURLLocaleMapping[defaultLocale] ?? '';

        dispatch(actions.updateLottoRootURL({ lottoRootURL }));
    }, [
        lang,
        dispatch,
        defaultLocale,
        lottoRootURLLocaleMapping
    ]);
};
